export default {"src":"/_next/static/media/star.06b4534c.svg","height":12,"width":13};